import type { NextPage } from 'next';
import { PAGE_OPTIONS } from '../../lib/utils/page';
import { FormPageTemplate } from '../../page-templates/form-page';
const SchoolRequest: NextPage = () => <FormPageTemplate {...PAGE_OPTIONS.SCHOOL_REQUEST} data-sentry-element="FormPageTemplate" data-sentry-component="SchoolRequest" data-sentry-source-file="index.tsx" />;
export default SchoolRequest;